import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

export const TokenProjectStatus = {
  idle: 'idle',
  fetchingProject: 'fetchingProject',
  tokenProjectLoaded: 'tokenProjectLoaded',
  tokenProjectNotFound: 'tokenProjectNotFound',
} as const;
export type TokenProjectStatus =
  (typeof TokenProjectStatus)[keyof typeof TokenProjectStatus];
export type TokenProjectState =
  | {
      status: typeof TokenProjectStatus.idle;
    }
  | {
      status: typeof TokenProjectStatus.fetchingProject;
      token: string;
    }
  | {
      status: typeof TokenProjectStatus.tokenProjectLoaded;
      token: string;
      projectId: string;
    }
  | {
      status: typeof TokenProjectStatus.tokenProjectNotFound;
      token: string;
      error: string;
    };
const initialTokenProjectState: TokenProjectState = {
  status: TokenProjectStatus.idle,
};

export interface ProjectIndexState {
  projectSearchIndex?: any; // lunr.Index after dynamic load
  tokenProjectState: TokenProjectState;
}

@Injectable()
export class ProjectIndexStore extends ComponentStore<ProjectIndexState> {
  constructor() {
    super({
      tokenProjectState: initialTokenProjectState,
    });
  }
}
